export const AdServerCreativeType = {
	SQTV: 'CreativeSQTVContent',
	QTV: 'CreativeQTVContent',
	FREE_TRIAL: 'CreativeFreeTrialContent',
} as const;

type AdServerCreativeTypename = (typeof AdServerCreativeType)[keyof typeof AdServerCreativeType];

export function isAdServerCreative(
	ad: { __typename?: string | null } | null | undefined
): ad is NonNullable<typeof ad> & { __typename: AdServerCreativeTypename } {
	return (
		ad?.__typename === AdServerCreativeType.SQTV ||
		ad?.__typename === AdServerCreativeType.QTV ||
		ad?.__typename === AdServerCreativeType.FREE_TRIAL
	);
}
